export const VUEX_PREMEDIA_SEARCH_UPDATE_PRODUCT_TERM   = 'VUEX_PREMEDIA_SEARCH_UPDATE_PRODUCT_TERM'
export const VUEX_PREMEDIA_SEARCH_GET_PRODUCTS          = 'VUEX_PREMEDIA_SEARCH_GET_PRODUCTS'
export const VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_SUCCESS  = 'VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_SUCCESS'
export const VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_FAILURE  = 'VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_FAILURE' 
export const VUEX_PREMEDIA_SEARCH_CLEAR_PRODUCT_DATA    = 'VUEX_PREMEDIA_SEARCH_CLEAR_PRODUCT_DATA'

export const VUEX_PREMEDIA_SEARCH_UPDATE_ASSET_TERM     = 'VUEX_PREMEDIA_SEARCH_UPDATE_ASSET_TERM'
export const VUEX_PREMEDIA_SEARCH_GET_ASSETS            = 'VUEX_PREMEDIA_SEARCH_GET_ASSETS'
export const VUEX_PREMEDIA_SEARCH_GET_ASSETS_SUCCESS    = 'VUEX_PREMEDIA_SEARCH_GET_ASSETS_SUCCESS'
export const VUEX_PREMEDIA_SEARCH_GET_ASSETS_FAILURE    = 'VUEX_PREMEDIA_SEARCH_GET_ASSETS_FAILURE'
export const VUEX_PREMEDIA_SEARCH_CLEAR_ASSET_DATA      = 'VUEX_PREMEDIA_SEARCH_CLEAR_ASSET_DATA'

export const VUEX_PREMEDIA_SEARCH_GET_ROWS              = 'VUEX_PREMEDIA_SEARCH_GET_ROWS'
export const VUEX_PREMEDIA_SEARCH_GET_ROWS_SUCCESS      = 'VUEX_PREMEDIA_SEARCH_GET_ROWS_SUCCESS'